import React, { useState } from "react";
import { PrimaryCTA } from "@/components/revanche/PrimaryCTA";
import { haptic } from "@/lib/design";
import { getSessionId } from "@/lib/api";
import { accountInput } from "@/lib/testmode";

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// Étape compte : e-mail uniquement, directement sur la page.
export const AccountStep = ({ onDone }) => {
    const [value, setValue] = useState("");
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState("");
    const valid = EMAIL_RE.test(value.trim());

    const submit = async () => {
        if (!valid || busy) return;
        setBusy(true);
        setError("");
        haptic();
        try {
            await accountInput(getSessionId(), value.trim().toLowerCase());
            onDone();
        } catch (e) {
            setBusy(false);
            setError("E-mail invalide, réessaie.");
        }
    };

    return (
        <div className="flex-1 flex flex-col">
            <img src="/brand/logo-glowup.png" alt="Glow Up IA" className="mx-auto" style={{ width: 120, height: "auto", marginTop: 4, marginBottom: 20 }} />
            <input
                data-testid="input-account-email"
                data-clarity-mask="true"
                type="email"
                inputMode="email"
                autoComplete="email"
                autoFocus
                placeholder="ton@email.com"
                value={value}
                onChange={(e) => { setValue(e.target.value); if (error) setError(""); }}
                onKeyDown={(e) => { if (e.key === "Enter") submit(); }}
                className="w-full font-body outline-none"
                style={{
                    height: "var(--h-field)", padding: "0 16px", borderRadius: "var(--radius-field)",
                    backgroundColor: "var(--surface)", border: "1px solid var(--border)", color: "var(--text)", fontSize: "16px",
                }}
            />
            {error && (
                <p data-testid="account-error" className="font-body" style={{ marginTop: 8, fontSize: 13, color: "var(--red)" }}>{error}</p>
            )}
            <div className="mt-3">
                <PrimaryCTA dataTestId="btn-account-email-continue" onClick={submit} disabled={!valid || busy}>
                    Continuer
                </PrimaryCTA>
            </div>
        </div>
    );
};
